import { ReceptionBooking } from '@models/reception'
import { ReceptionBookingDetailsImprovement } from '@models/booking'

export const hasVip = (booking: ReceptionBooking) =>
  booking.improvements.some((improvement: ReceptionBookingDetailsImprovement) => improvement.code === 'package_vip')
